import React, { useMemo } from 'react';
import useRevenueBySegments from '../../hooks/useRevenueBySegments';
import Table from '../Table/Table';
import style from './RevenueSources.module.css';
import { formatCurrency } from '../../helpers/format';

const RevenueSourcesSegments = ({ stock }) => {
  const { revenueBySegments } = useRevenueBySegments(stock.id);

  const totalRevenue = useMemo(() => {
    if (!revenueBySegments) return 0;
    return revenueBySegments.reduce((sum, item) => {
      const revenue = parseFloat(item.revenue);
      return sum + (revenue || 0)
    }, 0);
  }, [revenueBySegments]);

  if (!revenueBySegments || totalRevenue === 0) {
    return (
      <div>
        <p className={style.noData}>No data</p>
      </div>
    );
  }

  return (
    <Table>
      <tbody>
        {revenueBySegments.map((item) => {
          const revenue = parseFloat(item.revenue) || 0;
          const percentage = (revenue && totalRevenue !== 0) ? ((revenue / totalRevenue) * 100).toFixed(2) : 0;
          return (
            <tr key={item.product_name}>
              <th>{item.product_name}</th>
              <td className={style.points}>
                ${formatCurrency(revenue, { compact: true })}
                {' '}
                <span className={style.percentage}>
                  ({percentage}%)
                </span>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default RevenueSourcesSegments;
